// extracted by mini-css-extract-plugin
module.exports = {"sliderDot":"styles_sliderDot__308Oy","activeSliderDot":"styles_activeSliderDot__3LmJE"};